import { useTranslation } from 'react-i18next';
import { Style } from './style';
import ProjectTag from '../../../../../../../components/Tags/ProjectTag';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

export const renderIcon = ({ isOwnData, item, t }) => {
  if (isOwnData) {
    if (!item.disabled) {
      return (
        <ProjectTag color="blue">
          {t('Included')}
        </ProjectTag>
      );
    }

    return (
      <ProjectTag>
        {t('Not Included')}
      </ProjectTag>
    );
  }

  switch (item.status) {
    case 'approved':
      return (
        <ProjectTag color="green">
          {t('Approved')}
        </ProjectTag>
      );

    case 'deleted':
    case 'rejected':
      return (
        <ProjectTag color="red">
          {t('Declined')}
        </ProjectTag>
      )
    case 'unsaved':
      return (
        <ProjectTag color="volcano">
          {t('Unsaved')}
        </ProjectTag>
      )
    default:
      return (
        <ProjectTag color="orange">
          {t('Pending')}
        </ProjectTag>
      );
  }
};

const Item = ({ item = {}, setSelectedItem, isActive }) => {
  const { t } = useTranslation();
  const { data = {}, isOwnData, sourceName } = item || {};

  return (
    <div
      className={formatClassname(['px-md item', isActive && 'active'])}
      onClick={() => setSelectedItem(item.authorId)}
    >
      <div className="main">
        <label>
          {isOwnData ? t('Own Data') : (sourceName || data.name)}
        </label>
      </div>
      {renderIcon({ t, isOwnData, item })}
    </div>
  );
}

export default function ItemsList({
  items = [],
  setSelectedItem = () => { },
  selectedItem,
}) {
  return (
    <Style>
      {items.map((_item) => (
        <Item
          item={_item}
          key={`items-list-${_item.authorId}`}
          setSelectedItem={setSelectedItem}
          isActive={selectedItem === _item.authorId}
        />
      ))}
    </Style>
  );
}
